import React from 'react';
import { useTranslation } from 'react-i18next';
import Alert from '../../common/components/Alert';
import { ErrorListStyles } from '../styles/errorList';
import { getPasswordStrength, getPasswordStrengthMessageList } from '../utils/validation';

interface PasswordStrengthMessagesProps {
  password: string;
  email?: string;
  className?: string;
  showMessageOnLoad?: true;
}

export const PasswordStrengthMessages = (props: PasswordStrengthMessagesProps): JSX.Element => {
  const { t } = useTranslation();
  const classes = ErrorListStyles();
  /** PasswordMessages */

  let passwordStrings: Array<string> = [];
  if (props.password !== '' || props.showMessageOnLoad) {
    const passwordStrength = getPasswordStrength(props.password);
    passwordStrings = getPasswordStrengthMessageList(passwordStrength, props.email);
  }

  return (
    <Alert gridClassName={props.className} show={passwordStrings.length > 0} state="info">
      <ul className={classes.noMargin}>
        {passwordStrings && passwordStrings.map((msgs, index) => <li key={index}>{t(msgs)}</li>)}
      </ul>
    </Alert>
  );
};
